module.exports = __webpack_public_path__ + "static/media/exukonline-goods-recieved.e797dd1b.jpg";